// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClaimPopup_content_container__oFxTG {
  padding: 5px;
}

.ClaimPopup_claim_hr__Qke28 {
  height: 1px;
  border: none;
  background-color: var(--color-theme-silver);
  margin: 10px 0px;
  width: 100%;
}

.ClaimPopup_btn_additional_fees__FZ8IR {
  flex: 2 1;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  height: 40px;
  max-width: 300px !important;
  min-width: 200px !important;
  line-height: 0px !important;
  border: 1px solid var(--color-font-10) !important;
}

.ClaimPopup_findings_container__Xemgw {
  display: block;
}

.ClaimPopup_finding_container__l9ecq {
  display: flex;
  align-items: flex-start;
}

.ClaimPopup_finging_image_container__FsMNc {
  width: 100px;
}

.ClaimPopup_finging_image__3bJ\\+8 {
  height: 55px;
  padding-top: 15px;
  padding-left: 5px;
  width: 100%;
  border-radius: 2px;
  object-fit: cover;
}

.ClaimPopup_finging_details_container__mf0Aw {
  width: 220px;
  padding: 6px 20px;
}

.ClaimPopup_finding_id__HynTY {
  font-size: 12px;
}

.ClaimPopup_finding_link__a-\\+NQ {
  text-decoration: none;
  color: var(--color-font-10);
}

.ClaimPopup_finging_price_container__F5C2D {
  width: 220px;
}

.ClaimPopup_add_fee_container__yAPHq {
  text-align: right;
}

.ClaimPopup_additional_fees_container__txeNo {
  display: block;
}

.ClaimPopup_additional_fee_container__Y9Pkc {
  display: flex;
}

.ClaimPopup_other_fees_container__WDeYU {
  display: block;
}

.ClaimPopup_vat_container__1QJ1B {
  display: flex;
  justify-content: space-between;
}

.ClaimPopup_vat_two_inputs__IHHEv {
  display: flex;
  justify-content: space-between;
  width: 65%;
}

::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

.ClaimPopup_first_input__BcTph {
  margin-right: 20px !important;
}

.ClaimPopup_input_small__md\\+qV {
  width: 174px !important;
}

.ClaimPopup_settelment_container__RpDra {
  display: flex;
  justify-content: space-between;
}

.ClaimPopup_taxable_switch_container__D9YEz {
  display: block;
  width: 190px;
  padding-top: 5px;
}

.ClaimPopup_valid_note__QBga2 {
  padding-top: 10px;
  text-align: center;
}

.ClaimPopup_taxable_label__mEpOq {
  font-size: 10px;
  text-align: center;
}

.ClaimPopup_taxable_switch__cgE2X {
  margin-left: 10px !important;
  margin-top: 0px !important;
}

.ClaimPopup_btn_delete_container__lunvp {
  width: 90px;
  padding-top: 35px;
  text-align: left;
  color: var(--color-theme-red);
}

.ClaimPopup_summary_container__GOxDU {
  display: flex;
  justify-content: space-between;
  background-color: var(--color-theme-darkgray);
  padding: 5px 15px;
}

.ClaimPopup_license_container__WROWQ {
  margin-right: 15px;
}

.ClaimPopup_gross_container__iunn\\+ {
  margin-right: 15px;
}

.ClaimPopup_discount_container__Qpmoa {
  margin-right: 15px;
}

.ClaimPopup_sumary_label__fGTgq {
  font-size: 12px;
}

.ClaimPopup_sumary_value__57bSp {
  font-size: 18px;
  font-weight: bold;
}

.ClaimPopup_no_findings__\\+VZ2S {
  text-align: center;
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ClaimPopup/ClaimPopup.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".content_container {\n  padding: 5px;\n}\n\n.claim_hr {\n  height: 1px;\n  border: none;\n  background-color: var(--color-theme-silver);\n  margin: 10px 0px;\n  width: 100%;\n}\n\n.btn_additional_fees {\n  flex: 2;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  height: 40px;\n  max-width: 300px !important;\n  min-width: 200px !important;\n  line-height: 0px !important;\n  border: 1px solid var(--color-font-10) !important;\n}\n\n.findings_container {\n  display: block;\n}\n\n.finding_container {\n  display: flex;\n  align-items: flex-start;\n}\n\n.finging_image_container {\n  width: 100px;\n}\n\n.finging_image {\n  height: 55px;\n  padding-top: 15px;\n  padding-left: 5px;\n  width: 100%;\n  border-radius: 2px;\n  object-fit: cover;\n}\n\n.finging_details_container {\n  width: 220px;\n  padding: 6px 20px;\n}\n\n.finding_id {\n  font-size: 12px;\n}\n\n.finding_link {\n  text-decoration: none;\n  color: var(--color-font-10);\n}\n\n.finging_price_container {\n  width: 220px;\n}\n\n.add_fee_container {\n  text-align: right;\n}\n\n.additional_fees_container {\n  display: block;\n}\n\n.additional_fee_container {\n  display: flex;\n}\n\n.other_fees_container {\n  display: block;\n}\n\n.vat_container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.vat_two_inputs {\n  display: flex;\n  justify-content: space-between;\n  width: 65%;\n}\n\n::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n}\n\n.first_input {\n  margin-right: 20px !important;\n}\n\n.input_small {\n  width: 174px !important;\n}\n\n.settelment_container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.taxable_switch_container {\n  display: block;\n  width: 190px;\n  padding-top: 5px;\n}\n\n.valid_note {\n  padding-top: 10px;\n  text-align: center;\n}\n\n.taxable_label {\n  font-size: 10px;\n  text-align: center;\n}\n\n.taxable_switch {\n  margin-left: 10px !important;\n  margin-top: 0px !important;\n}\n\n.btn_delete_container {\n  width: 90px;\n  padding-top: 35px;\n  text-align: left;\n  color: var(--color-theme-red);\n}\n\n.summary_container {\n  display: flex;\n  justify-content: space-between;\n  background-color: var(--color-theme-darkgray);\n  padding: 5px 15px;\n}\n\n.license_container {\n  margin-right: 15px;\n}\n\n.gross_container {\n  margin-right: 15px;\n}\n\n.discount_container {\n  margin-right: 15px;\n}\n\n.sumary_label {\n  font-size: 12px;\n}\n\n.sumary_value {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.no_findings {\n  text-align: center;\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `ClaimPopup_content_container__oFxTG`,
	"claim_hr": `ClaimPopup_claim_hr__Qke28`,
	"btn_additional_fees": `ClaimPopup_btn_additional_fees__FZ8IR`,
	"findings_container": `ClaimPopup_findings_container__Xemgw`,
	"finding_container": `ClaimPopup_finding_container__l9ecq`,
	"finging_image_container": `ClaimPopup_finging_image_container__FsMNc`,
	"finging_image": `ClaimPopup_finging_image__3bJ+8`,
	"finging_details_container": `ClaimPopup_finging_details_container__mf0Aw`,
	"finding_id": `ClaimPopup_finding_id__HynTY`,
	"finding_link": `ClaimPopup_finding_link__a-+NQ`,
	"finging_price_container": `ClaimPopup_finging_price_container__F5C2D`,
	"add_fee_container": `ClaimPopup_add_fee_container__yAPHq`,
	"additional_fees_container": `ClaimPopup_additional_fees_container__txeNo`,
	"additional_fee_container": `ClaimPopup_additional_fee_container__Y9Pkc`,
	"other_fees_container": `ClaimPopup_other_fees_container__WDeYU`,
	"vat_container": `ClaimPopup_vat_container__1QJ1B`,
	"vat_two_inputs": `ClaimPopup_vat_two_inputs__IHHEv`,
	"first_input": `ClaimPopup_first_input__BcTph`,
	"input_small": `ClaimPopup_input_small__md+qV`,
	"settelment_container": `ClaimPopup_settelment_container__RpDra`,
	"taxable_switch_container": `ClaimPopup_taxable_switch_container__D9YEz`,
	"valid_note": `ClaimPopup_valid_note__QBga2`,
	"taxable_label": `ClaimPopup_taxable_label__mEpOq`,
	"taxable_switch": `ClaimPopup_taxable_switch__cgE2X`,
	"btn_delete_container": `ClaimPopup_btn_delete_container__lunvp`,
	"summary_container": `ClaimPopup_summary_container__GOxDU`,
	"license_container": `ClaimPopup_license_container__WROWQ`,
	"gross_container": `ClaimPopup_gross_container__iunn+`,
	"discount_container": `ClaimPopup_discount_container__Qpmoa`,
	"sumary_label": `ClaimPopup_sumary_label__fGTgq`,
	"sumary_value": `ClaimPopup_sumary_value__57bSp`,
	"no_findings": `ClaimPopup_no_findings__+VZ2S`
};
export default ___CSS_LOADER_EXPORT___;
